export const AppTransComponents = {
    bold: <strong />,
    italic: <i />
};
